module.exports = __webpack_public_path__ + "img/arm-right-front.1fed4eac.png";